<template>
  <div class="row mx-2 my-3 pricelist-settings">
    <div class="col-md-12">
      <div class="row">
        <div class="col-sm-12 col-md-7">
          <h3>Order Minimum Qty Settings</h3>
        </div>
        <div class="col-sm-12 col-md-3 text-right">

        </div>
        <div class="col-sm-12 col-md-2 text-right">

        </div>
      </div>

      <div class="row my-3 mx-1 py-2" style="background-color: #e5e5e5;">
        <div class="col-sm-5">
          <h3 class="m-0">All Locations (Default)</h3>
        </div>
        <div class="col-sm-5">
          <h3 class="m-0">Min Qty: {{ minimumQuantity }}</h3>
        </div>
        <div class="col-sm-2">
          <div class="d-flex align-items-center">
            <input type="number" v-model="defaultMinimumQuantity" name="max_order" class="form-control mr-3" />
            <button @click="updateDefaultQuantity()" type="button"
              class="btn btn-outline-speq text-speq text-uppercase">
              Update
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-7"></div>
        <div class="col-sm-12 col-md-3 text-right"></div>
        <div class="col-sm-12 col-md-2 text-right">
          <span v-if="user.role.id == 1" class="add-button btn btn-action" @click="openModal(null, 'add', false)">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            ADD CUSTOM RULE
          </span>
        </div>
      </div>

      <table class="table table-responsive table-striped border-bottom mt-2">
        <thead class="thead-light">
          <tr>
            <!-- <th>User</th> -->
            <th>Dealer</th>
            <th style="width: 8em">Minimum Quantity</th>
            <th style="width: 25em"></th>
            <th style="width: 8em"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customRule in customRulesLocations.data" :key="customRule.id">
            <td>
              {{ customRule.location.name }}
            </td>
            <td class="text-center">{{ customRule.value.quantity }}</td>
            <td>
              <div class="row align-items-center">
                <div class="col-auto">
                  <input type="number" v-model="customRuleInputs[customRule.id]" class="form-control" />
                </div>
                <div class="col-auto">
                  <button 
                    class="btn btn-primary"
                    @click="updateLocationQuantity(customRule.location_id, customRuleInputs[customRule.id])"
                  >
                    Update
                  </button>
                </div>
              </div>
            </td>
            <td>
              <span class="px-2 view-action font-weight-bold">TRASH</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Confirmation modal -->
  <b-modal v-model="modalShow" :title="modalType == 'add' ? 'ADD CUSTOM RULE' : 'EDIT CUSTOM RULE'" hide-footer>
    <OrderMinimumQuantitySettingModal
      v-if="modalShow"
      :modal-data="modalData"
      :modal-type="modalType"
      :modal-setting="modalSetting"
      @close-modal="closeModal"
      :updateTable="getResults"
      :all-locations="allLocations"
    />
  </b-modal>
</template>
<script>
import { Bootstrap4Pagination } from "laravel-vue-pagination";
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import OrderMinimumQuantitySettingModal from "@/components/modals/OrderMinimumQuantitySettingModal.vue";

export default {
  props: [],
  emits: [],
  components: {
    Bootstrap4Pagination,
    OrderMinimumQuantitySettingModal
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const user = computed(() => store.state.user);
    const minimumQuantity = computed(() => store.getters.getOrderDefaultMinimumQuantity);
    const customRulesLocations = computed(() => store.getters.getCustomRulesLocations);
    const allLocations = computed(() => store.getters.allLocations);

    onMounted(async () => {
      await store.dispatch('getMinimumQuantity');
      await store.dispatch('getAllLocations');
    });

    return {
      store,
      route,
      user,
      minimumQuantity,
      customRulesLocations,
      allLocations
    };
  },
  data() {
    return {
      defaultMinimumQuantity: null,
      perPage: 50,
      searchTerm: "",
      modalShow: false,
      modalType: null,
      modalSetting: null,
      modalData: {},
      customRuleInputs: []
    }
  },
  async mounted() {
    await this.getResults();
  },
  methods: {
    async updateDefaultQuantity() {
      await this.store.dispatch('updateDefaultMinimumQuantity', this.defaultMinimumQuantity);
    },
    async updateLocationQuantity(location_id, quantity) {
      await this.$store.dispatch('setLocationOrderMinimumQuantity', {
        location_id,
        quantity
      });

      window.emitter.emit("alertSuccess", {
        message: "Done updating the custom rule.",
      });

      this.customRuleInputs = []
    },
    openModal(data, type, defaultSetting) {
      this.modalType = type;
      this.modalData = data;
      this.modalSetting = defaultSetting;
      this.modalShow = !this.modalShow;
    },
    closeModal() {
      this.modalShow = !this.modalShow;
      this.getResults();

      window.emitter.emit("alertSuccess", {
        message: "Done updating the custom rule.",
      });
    },
    async getResults(page = 1) {
      try {
        await this.store.dispatch('fetchLocationsWithCustomRules', {
          page: page,
          per_page: this.perPage
        });
      } catch (err) {
        console.error(err);
      }
    }
  }
}
</script>